module.exports = __webpack_public_path__ + "img/9788980406784.71ed6c80.jpg";